<template>
  <v-container>
    <v-layout row wrap>
      <v-flex>
        <history title="Historia" :show-more="false" />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { sharedConfig } from '@witkac/kartamiejska-shared';

import store from '@/store/store';
import History from '@/components/history/History';
import { SessionStorage } from '@/enums/sessionStorage.enum';

/**
 * @vuese
 * Strona historii użycia usług
 * @group History
 */
export default {
  components: { History },
    beforeRouteEnter(to, from, next) {
      loadHistory(to)
      .then(() => next())
      .catch(err =>
        store.dispatch('notifyError', {
          title: 'Wystąpił błąd podczas pobierania listy usług.',
          messages: [error.message || error]
        })
      );
  },
  beforeRouteUpdate(to, from, next) {
    loadHistory(to).then(() => next());
  }
};

/**
 * Załadowanie historii usług
 *
 */
function loadHistory(route) {
  return store.dispatch('benefitsUsage/list', {
        profileId: parseInt(sessionStorage.getItem(SessionStorage.PROFILE_ID)),
        count: sharedConfig.onPage,
        order: 'created',
        desc: true
      });
}
</script>